module.exports = __webpack_public_path__ + "img/sub.28e4b73a.png";